import { Injectable } from "@angular/core";
import {
  AcepSSOService,
  GlobalDomOpsService,
  GlobalDataOpsService,
  CommonOperationsService
} from "@acepteam/globalspack";
import { GroupPortalDomService } from "../../services";
import {
  DomService,
  DataService,
  HelperService,
  LoggerService
} from "../../../core/services";
import { MyAccountDataOpsService } from "../../services/my-account-dataops.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { EducationDetails, Address } from "../../../shared/models";
import { FormGroup } from "@angular/forms";
import { MemberType } from "../../../shared/enums/data.enums";
declare var $;
declare var moment;

@Injectable({
  providedIn: "root"
})
export class Component2Service {
  constructor(
    private ssoService: AcepSSOService,
    private globalDomOpsService: GlobalDomOpsService,
    private memberAppDomService: GroupPortalDomService,
    private domService: DomService,
    private globalDataOpsService: GlobalDataOpsService,
    private dataService: DataService,
    private myAccountDataService: MyAccountDataOpsService,
    private commonOpsService: CommonOperationsService,
    private helperService: HelperService,
    private loggerService: LoggerService,
    private http: HttpClient
  ) {}

  saveEducationDetails(education: EducationDetails): HttpResponse<any> | any {
    let payload = {
      contactid: this.ssoService.contactid,
      education: education
    };
    return this.http.post(
      this.dataService.groupportalapiendpoint + "UpdateEducation",
      JSON.stringify(payload)
    );
  }

  prepareDataModel(
    educationDetails: EducationDetails,
    educationForm: FormGroup
  ): EducationDetails {
    let p: EducationDetails = Object.assign(
      {},
      educationDetails
    ) as EducationDetails;

    let ms = educationForm.value.medicalSchool;
    let r = educationForm.value.residency;
    let f = educationForm.value.fellowship;
    let bc = educationForm.value.boardCertification;

    if (ms) {
      if (!ms.address) {
        ms.address = new Address();
      }
      if (ms.address.address2 != "" && ms.address.address2 != undefined) {
        //include name in the answer value so it can be retrieved back
        //This will be popped out later to assign to name and remainder assgined to adress object
        let answervalue = $.extend(ms.address, { name: ms.accountLookUp.name });
        ms.metadata.answervalue = JSON.stringify(answervalue);
      }

      p.medicalSchool = {
        id: ms.accountLookUp.id,
        contactmedicalschoolid: ms.contacteducationchildid || "",
        name: ms.accountLookUp.name,
        graduationdate: this.commonOpsService.SantizeDate(
          ms.graduation.graduationdate
        ),
        address: ms.address,
        metadata: ms.metadata
      };
    }

    if (r) {
      if (!r.address) {
        r.address = new Address();
      }
      if (r.address.address2 != "" && r.address.address2 != undefined) {
        //include name in the answer value so it can be retrieved back
        //This will be popped out later to assign to name and remainder assgined to adress object
        let answervalue = $.extend(r.address, { name: r.accountLookUp.name });
        r.metadata.answervalue = JSON.stringify(answervalue);
      }

      p.residency = {
        id: r.accountLookUp.id,
        contactresidencyid: r.contacteducationchildid || "",
        name: r.accountLookUp.name,
        graduationdate: this.commonOpsService.SantizeDate(
          r.graduation.graduationdate
        ),
        specialtyid: r.specialityid,
        address: r.address,
        metadata: r.metadata
      };
    }

    if (f) {
      if (!f.address) {
        f.address = new Address();
      }
      if (f.address.address2 != "" && f.address.address2 != undefined) {
        //include name in the answer value so it can be retrieved back
        //This will be popped out later to assign to name and remainder assgined to adress object
        let answervalue = $.extend(f.address, { name: f.accountLookUp.name });
        f.metadata.answervalue = JSON.stringify(answervalue);
      }

      p.fellowship = {
        id: f.accountLookUp.id,
        contactfellowshipid: f.contacteducationchildid || "",
        name: f.accountLookUp.name,
        graduationdate: this.commonOpsService.SantizeDate(
          f.graduation.graduationdate
        ),
        specialtyid: "",
        subspecialtyid: "",

        address: f.address,
        metadata: f.metadata
      };
    }

    if (bc) {
      p.boardCertification = {
        id: bc.boardcertificationid,
        contactboardcertificationid: bc.contacteducationchildid || "",
        name: "",
        certificationnumber: "",
        effectivedate: "",
        expirationdate: this.commonOpsService.SantizeDate(
          bc.graduation.graduationdate
        )
      };
    }

    return p;
  }

  CheckIfFirstDateIsGreaterThanSecondDate(date1: any, date2: any) {
    return moment(date1) > moment(date2);
  }

  validateGradDates(ed: EducationDetails, mt: MemberType) {
    let errorMsg: string = "";
    let isValid: boolean = true;

    //Residency grad date ( if available) should be greater than Medical School grad date
    if (
      ed.residency.graduationdate &&
      this.CheckIfFirstDateIsGreaterThanSecondDate(
        ed.medicalSchool.graduationdate,
        ed.residency.graduationdate
      )
    ) {
      isValid = false;
    }

    //Fellowship grad date ( if available) should be greater than Residency grad date
    if (mt != MemberType.Student) {
      if (
        ed.fellowship.graduationdate &&
        this.CheckIfFirstDateIsGreaterThanSecondDate(
          ed.residency.graduationdate,
          ed.fellowship.graduationdate
        )
      ) {
        isValid = false;
      }
    }

    return isValid;
  }
}
